import throttle from 'lodash/throttle';

class ElementVisibility {
  element;

  callback;

  scrollHandlerThrottle;

  isVisible;

  padding;

  constructor(element, callback, padding = 50) {
    this.element = element;
    this.callback = callback;
    this.padding = padding;
    this.scrollHandlerThrottle = throttle(() => this.scrollHandler(), 100);
    document.addEventListener('scroll', this.scrollHandlerThrottle);

    callback(this.checkIfVisible());
  }

  checkIfVisible() {
    const { bottom, top } = this.element.getBoundingClientRect();

    const isBelow = bottom + this.padding < 0;
    const isAbove = top - this.padding > window.innerHeight;
    this.isVisible = !isAbove && !isBelow;
    return {
      isVisible: this.isVisible,
      isAbove,
      isBelow,
    };
  }

  scrollHandler() {
    const wasVisible = this.isVisible;
    const { isVisible, isAbove, isBelow } = this.checkIfVisible();

    if (wasVisible !== isVisible) {
      this.callback({ isVisible, isAbove, isBelow });
    }
  }

  destroy() {
    document.removeEventListener('scroll', this.scrollHandlerThrottle);
  }
}

export default ElementVisibility;
